import React from 'react';
import './Checkbox.css';
import Icon from './icons/Icon';

export interface CheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  id?: string;
  onDisabledClick?: () => void; // disabledの時にも呼び出されるクリックハンドラー
}

const Checkbox: React.FC<CheckboxProps> = ({ 
  checked, 
  onChange, 
  disabled = false,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
  id,
  onDisabledClick
}) => {
  return (
    <div className="checkbox-container">
      <button
        id={id}
        className={`checkbox ${checked ? 'checkbox--checked' : ''} ${disabled ? 'checkbox--disabled' : ''}`}
        onClick={disabled ? onDisabledClick : () => onChange?.(!checked)}
        type="button"
        disabled={false} // disabledの時でもクリックを受け付けるようにfalseに設定
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledby}
        aria-pressed={checked}
        role="checkbox"
        aria-checked={checked}
      >
        <div className="checkbox__base">
          <div className="checkbox__state-layer">
            <div className={`checkbox__boxicon ${checked ? 'checkbox__boxicon--checked' : ''}`}>
              {checked && <Icon name="check" size={18} />}
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default Checkbox;